import React from 'react'
import {Button} from "../overloaded/Button";

export const DonateButton = () => (
    <Button variant="contained" size="small" target="_blank" href="https://www.patreon.com/twoblokesafloat">Donate</Button>
);